import { promise } from 'protractor';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { LoadingController, AlertController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { UnsavedSceneService } from './unsaved-scene.service';
import { MediaAsset } from '../models/assets/MediaAsset';
import { AssetInScene } from '../models/AssetInScene';
// import { SceneBackground } from '../models/SceneBackground';
import { ValidationService } from './validation.service';
import { Scene } from '../models/Scene';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
import { NgxImageCompressService } from 'ngx-image-compress';
import { AssetTypeService } from './asset-type.service';
import { ApiSceneService } from '../api-services/scene.api.service';
import { ApiAssetService } from '../api-services/asset.api.service';
import { ApiQuestionResponseService } from '../api-services/question-response.api.service';
import { FileSizeService } from './file-size.service';
import { CustomerService } from './customer.service';
import { CryptoService } from './crypto.service';

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

@Injectable({
  providedIn: 'root'
})
export class FileService {

  public videosToCheckUploadStatus: any[] = [];
  public videosToCheckUploadStatusInterval = null;
  //public videoAssetUploadingPlaceholder: string = 'https://ecomstorageproduction.blob.core.windows.net/assessing-reality/5a0ffb5a-475d-4307-bf05-237f82a9302d/9bc96c7a-c768-4ecd-9812-bdf55b638343';
  public videoAssetUploadingPlaceholder: string = 'assets/enetreality-upload-screen.mp4';
  public loading;

  constructor(
    private httpClient: HttpClient,
    public loadingController: LoadingController,
    public unsavedSceneService: UnsavedSceneService,
    public alertController: AlertController,
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
    public imageCompressService: NgxImageCompressService,
    public sceneAPIService: ApiSceneService,
    public assetAPIService: ApiAssetService,
    public questionResponseAPIService: ApiQuestionResponseService,
    public fileSizeService: FileSizeService,
    public customerService: CustomerService,
    public cryptoService: CryptoService
  ) {

  }

  async getBlobStorageLocation() {
    var blob = await this.customerService.getCustomerBlobStorage();
    switch (this.customerService.customer.blobStorageLocation) {
      case "Africa":
        return "enetrealitystorageafrica";
      case "East Asia":
        return "enetrealitystorageeasia";
      case "South East Asia":
        return "enetrealitystorageseasia";
      case "India":
        return "enetrealitystorageindia";
      case "UAE":
        return "enetrealitystorageuae";
      case "UK":
        return "enetrealitystorageuk";
      case "US East":
        return "enetrealitystorageeastus";
      case "US North":
        return "enetrealitystorageus";
      case "US West":
        return "enetrealitystoragewestus";
      case "West Europe":
        return "enetrealitystoragewesteu";
      default:
        return "enetrealitystorageuk"
    }
  }

  async fileEvent(event, projectId: string, obj: any, param: string) {
    var type: string = this.assetTypeService.getType(obj.assetTypeId);
    if (event.target.files.length > 0) {
      if (type == "Model3D") {
        await this.loadController('Loading 3D Model file.');
      }
      else if (type == "Invisible") {
        await this.loadController('Object Selection Tool.');
      } else {
        await this.loadController('Setting ' + type + ' to preview.');
      }
      var file = event.target.files[0];
      var fileName = file.name;
      var fileType = file.type;

      // SETTING THE FILE TO PREVIEW
      var reader = new FileReader();
      reader.onload = (e) => {
        var src = reader.result;
        this.loading.dismiss().then(() => {
          obj[param] = src;
        });
      }
      reader.readAsDataURL(file);

      /* var base64 = await toBase64(file);
      base64 = base64.toString().split(',')[1];
      this.uploadFile(base64, projectId).subscribe(res => {
        this.loading.dismiss().then(() => {
          obj[param] = "https://ecomstorageproduction.blob.core.windows.net/assessing-reality/"+ projectId +"/" + res;
        });

      },
      error => {
        this.loading.dismiss().then(() => {
          obj[param] = "https://ecomstorageproduction.blob.core.windows.net/assessing-reality/"+ projectId +"/" + error.error.text;
        });
      }); */
    }
  }

  async fileEventUpload(files, projectId: string, compressFile: boolean = false): Promise<string> {
    await this.loadController('Uploading file, please wait.');
    var blobStorageLoc = await this.getBlobStorageLocation();
    return new Promise<string>(async (resolve) => {
      var fileToUpload = files[0];
      var fileType = this.getFileType(files[0]);
      if (fileType == 'Image' && compressFile == true) {
        fileToUpload = await this.compressImage(fileToUpload);
      }
      this.uploadFile(fileType, fileToUpload, projectId, compressFile).subscribe(res => {
        this.loading.dismiss().then(() => {
          let src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + res;
          resolve(src);
        });
      },
        error => {
          this.loading.dismiss().then(() => {
            let src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + error.error.text;
            resolve(src);
          });
        });
    });
  }

  async replaceSceneBackgroundFile(event, projectId: string, compressFile: boolean = false): Promise<string> {
    let base64: any;
    var blobStorageLoc = await this.getBlobStorageLocation();
    var promise = new Promise<string>(async (resolve, reject) => {
      var fileToUpload = event;
      var fileType = this.getFileType(fileToUpload);
      if (fileType == 'Image' && compressFile == true) {
        fileToUpload = await this.compressImage(fileToUpload);
      }
      this.loadController('Uploading file, please wait.').then(() => {
        this.uploadFile(fileType, fileToUpload, projectId, compressFile).subscribe(res => {
          this.loading.dismiss().then(() => {
            let src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + res;
            resolve(src);
          });
        },
          error => {
            this.loading.dismiss().then(() => {
              let src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + error.error.text;
              resolve(src);
            });
          });
      });
    });
    return promise;

  }

  replaceMediaAssetFile(event, projectId: string, compressFile: boolean = false): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
      var blobStorageLoc = await this.getBlobStorageLocation();
      if (event.target.files.length > 0) {
        var fileToUpload = event.target.files[0];
        var fileType = this.getFileType(fileToUpload);

        if (fileType == 'Image' && compressFile == true) {
          fileToUpload = await this.compressImage(fileToUpload);
        }

        await this.loadController('Uploading file, please wait.');

        this.uploadFile(fileType, fileToUpload, projectId, compressFile).subscribe(res => {
          this.loading.dismiss().then(() => {
            let src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + res;
            resolve(src);
          });
        },
          error => {
            this.loading.dismiss().then(() => {
              let src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + error.error.text;
              resolve(src);
            });
          });
      }
    });
  }

  async replaceAssetMedia(projectId: string, value: string, mediaAsset: MediaAsset, sceneAssetRelationId: number) {
    var blobStorageLoc = await this.getBlobStorageLocation();
    mediaAsset.src = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + value;
    //document.querySelector('#asset-' + sceneAssetRelationId).setAttribute('src', mediaAsset.src);
    //this.reappendSrc(sceneAssetRelationId);
  }

  async replacePanoAsset(projectId: string, value: string, scene: Scene) {
    var blobStorageLoc = await this.getBlobStorageLocation();
    scene.sceneBackgroundSrc = "https://" + blobStorageLoc + ".blob.core.windows.net/assessing-reality/" + projectId + "/" + value;
    scene.sceneBackgroundColour = "#FFFFFF";
  }

  reappendSrc(sceneAssetRelationId) {
    var entity = document.getElementById('entity-' + sceneAssetRelationId);
    var childEntity = null;
    if (!entity) {
      return;
    }

    childEntity = entity.querySelector('a-sound');
    if (!childEntity) {
      childEntity = entity.querySelector('a-video');
      if (!childEntity) {
        childEntity = entity.querySelector('a-image');
      }
    }

    if (childEntity) {
      childEntity.setAttribute('src', '');
      setTimeout(function () {
        childEntity.setAttribute('src', '#asset-' + sceneAssetRelationId)
      }, 100);
    }

  }

  async loadController(msg) {
    this.loading = await this.loadingController.create({
      message: msg
    });

    this.loading.present();
  }

  uploadFile(fileType: string, file, projectId: string, compressFile: boolean): Observable<any> {
    var url = API_SETTINGS.API_URL + "file/Upload";
    const formData: FormData = new FormData();

    formData.append("customerId", this.cryptoService.decryptData(localStorage.getItem('customerId')));
    formData.append("projectId", projectId);
    formData.append("file", file);
    formData.append("fileType", fileType);
    formData.append("compressFile", String(compressFile).toLowerCase());

    return this.httpClient.post<any>(url, formData);
  }

  compressImage(imageFile): Promise<File> {
    var orientation = -1;

    var promise = new Promise<File>((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        var image = event.target.result;
        var originalSize = this.imageCompressService.byteCount(image) / (1024 * 1024);
        this.imageCompressService.compressFile(image, orientation, 75, 50).then(result => {
          var compressedSize = this.imageCompressService.byteCount(result) / (1024 * 1024);
          var arr = result.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }

          const imageName = 'Compressed Image';
          const imageFile = new File([u8arr], imageName, { type: mime });

          resolve(imageFile);
        });
      }
      reader.readAsDataURL(imageFile);
    });

    return promise;
  }

  getFileType(file): string {
    var fileFormat = file.type;
    if (fileFormat.startsWith('image')) {
      return 'Image';
    }
    if (fileFormat.startsWith('video')) {
      return 'Video';
    }
    if (fileFormat.startsWith('audio')) {
      return 'Audio';
    }
    if (file.name) {
      var fileNameArray: string[] = file.name.split('.');
      if (fileNameArray[fileNameArray.length - 1] == 'glb') {
        return 'Model3D';
      }
    }
    return '';
  }

  addVideoToCheckUploadStatus(type: string, id: number, obj: any, src: string){
    this.removeFromVideosToCheckUploadStatus(type, id);
    this.videosToCheckUploadStatus.push({
      type,
      id,
      obj,
      src
    });
  }

  async checkVideosUploadStatus(): Promise<void> {
    return new Promise<void>((resolve) => {
      let videosToRemove: number[] = [];
      this.videosToCheckUploadStatus.forEach(videoToCheck => {
        if (this.srcExists(videoToCheck.src) === true) {
          videosToRemove.push(videoToCheck.id);
          this.setUploadStatusComplete(videoToCheck.type, videoToCheck.obj, videoToCheck.src);
        }
      });
      this.videosToCheckUploadStatus = this.videosToCheckUploadStatus.filter(v => !videosToRemove.includes(v.id));
      resolve();
    });
  }

  async setUploadStatusComplete(type: string, obj: any, src: string) {
    let fileSize = await this.fileSizeService.getFileSize(src);
    switch (type) {
      case 'scene': {
        obj.uploadStatus = 'complete';
        obj.sceneBackgroundSrc = src;
        obj.sceneBackgroundFileType = 'Video';
        obj.sceneBackgroundFileSize = fileSize;
        this.sceneAPIService.setSceneUploadStatusComplete(obj.sceneId, obj).subscribe();
        break;
      }
      case 'baseAsset': {
        obj.uploadStatus = 'complete';
        obj.src = src;
        obj.fileSize = fileSize;
        if (obj.baseAssetId)
          this.assetAPIService.setVideoUploadStatusComplete(obj.baseAssetId, obj).subscribe();

        break;
      }
      case 'questionResponse': {
        obj.uploadStatus = 'complete';
        obj.videoSrc = src;
        obj.videoFileSize = fileSize;
        if (obj.questionResponseId)
          this.questionResponseAPIService.setResponseUploadStatusComplete(obj.questionResponseId, obj).subscribe();

        break;
      }
      case 'managementPageBaseAsset': {
        obj.uploadStatus = 'complete';
        obj.src = src;
        obj.fileSize = fileSize;
        obj.size = this.fileSizeService.getFileSizeWithMetric(obj);
        this.assetAPIService.setVideoUploadStatusComplete(obj.baseAssetId, obj).subscribe();
        break;
      }
    }
  }

  initialiseVideoUploadStatusCheck() {

    if (this.videosToCheckUploadStatusInterval) {
      clearInterval(this.videosToCheckUploadStatusInterval);
      this.videosToCheckUploadStatusInterval = null;
    }

    this.checkVideosUploadStatus().then(() => {
      this.videosToCheckUploadStatusInterval = setInterval(async () => {
        if (this.videosToCheckUploadStatus.length == 0) {
          clearInterval(this.videosToCheckUploadStatusInterval);
          return;
        }

        await this.checkVideosUploadStatus();
      }, 5000);
    });
  }

  srcExists(url): boolean {
    let http = new XMLHttpRequest();

    http.open('HEAD', url, false);
    http.send();

    return http.status != 404;
  }

  getObjectSrc(type: string, id: number, index?: number): string{
    let src = null;
    switch (type) {
      case 'scene':
      case 'baseAsset':
      case 'managementPageBaseAsset': {
        let videoToCheck = this.videosToCheckUploadStatus.find(v => v.id == id);
        if (videoToCheck) src = videoToCheck.src;
        break;
      }
      case 'questionResponse': {
        let videoToCheck = this.videosToCheckUploadStatus.find(v => v.id == id && v.index == index);
        if (videoToCheck) src = videoToCheck.videoSrc;
        break;
      }
    }
    return src;
  }

  removeFromVideosToCheckUploadStatus(type: string, id: number, index?: number){
    switch(type){
      case 'scene': 
      case 'baseAsset': 
      case 'managementPageBaseAsset': {
        let videoToCheckIndex = this.videosToCheckUploadStatus.findIndex(v => v.id == id);
        if (videoToCheckIndex > -1) this.videosToCheckUploadStatus.splice(videoToCheckIndex, 1);
        break;
      }
      case 'questionResponse': {
        let videoToCheckIndex = this.videosToCheckUploadStatus.findIndex(v => v.id == id && v.index == index);
        if (videoToCheckIndex > -1) this.videosToCheckUploadStatus.splice(videoToCheckIndex, 1);
        break;
      }
    }
  }

}
